import { StepContent } from './stepContent.types';

export const savingLoaderContent: StepContent = {
  title: 'Analyzing your potential savings...',
};
